import { createSlice } from "@reduxjs/toolkit";
import { getLocalStorage, setLocalStorage } from "../../helper/Storage";

const initialState = {
  address: {},
  isLoading: false,
  error: null,
};

export const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    loadAddress: (state) => {
      const myAddress = getLocalStorage("myAddress");
      state.address = myAddress ? myAddress : {};
    },
    addAddress: (state, action) => {
      state.address = action.payload.address;
      setLocalStorage("myAddress", state.address);
    },
  },
});

export const { loadAddress, addAddress } = addressSlice.actions;

export default addressSlice.reducer;
